import { ThemeProvider } from './ThemeContext';
import { UserProvider } from './UserContext';
import { PropertyFiltersProvider } from './PropertyFiltersContext';
import { SaleAgentProvider } from './SaleAgentContext';

const combineProviders = (...providers: React.FC[]): React.FC => {
  return providers.reduce((AccumulatedProviders, CurrentProvider) => {
    return ({ children }: React.ComponentProps<React.FC>): JSX.Element => {
      return (
        <AccumulatedProviders>
          <CurrentProvider>{children}</CurrentProvider>
        </AccumulatedProviders>
      );
    }
  });
}

const providers = [
  ThemeProvider,
  UserProvider,
  SaleAgentProvider,
  PropertyFiltersProvider
]

export const AppContextProvider = combineProviders(...providers);


